import { Select, useFieldState } from 'informed';
import type { Form } from 'payments-lib-types';
import { type FC, useMemo } from 'react';
import { FormGroup } from '@/components/form/groups/FormGroup';
import { required } from '@/helpers/validators';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';

import { ScFieldExpiryDateRow } from './styled';

export const FieldCascadeSelect: FC<
  OfUnion<MethodField>[Form.MethodFieldType.CascadeSelect]
> = ({
  fieldName,
  label,
  options,
  secondaryFieldName,
  secondaryLabel,
  secondaryOptionsMapByMainValue,
  activeThemeMode,
}) => {
  const primaryOptionsFormatted = useMemo(
    () => options.map(({ label, value }) => ({ name: label, value })),
    [options]
  );

  const fieldStatePrimary = useFieldState<string>(fieldName);

  const selectedPrimary = useMemo(
    () => (fieldStatePrimary == null ? undefined : fieldStatePrimary.value),
    [fieldStatePrimary]
  );

  const secondaryOptionsFiltered = useMemo(() => {
    if (!selectedPrimary) return;

    const secondaryOptions = secondaryOptionsMapByMainValue[selectedPrimary];

    if (!secondaryOptions) return;

    return secondaryOptions.map(({ label, value }) => ({ name: label, value }));
  }, [selectedPrimary, secondaryOptionsMapByMainValue]);

  return (
    <FormGroup mode={activeThemeMode} title={label || fieldName}>
      <ScFieldExpiryDateRow $list>
        <Select
          dropdownUp
          field={fieldName}
          mode={activeThemeMode}
          options={primaryOptionsFormatted}
          placeholder={label || fieldName}
          validate={required}
        />

        {secondaryOptionsFiltered && (
          <Select
            dropdownUp
            field={secondaryFieldName}
            mode={activeThemeMode}
            options={secondaryOptionsFiltered}
            placeholder={secondaryLabel || secondaryFieldName}
            validate={required}
          />
        )}
      </ScFieldExpiryDateRow>
    </FormGroup>
  );
};
